
// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
import UIButton from "../../components/core/UIButton";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class BtnAreYouSureTick extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // btn_png
    const btn_png = scene.add.image(0, 0, "common", "popup-btn-right-green.png");
    this.add(btn_png);

    // icon_back_arrow_png
    const icon_back_arrow_png = scene.add.image(4, -7, "common", "popup-icon-tick.png");
    this.add(icon_back_arrow_png);

    // this (components)
    new UIButton(this);

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
